// extracted by mini-css-extract-plugin
export default {"card":"UserCard_card__lZWqG","avatar":"UserCard_avatar__qx8Iu"};